export default "__VITE_ASSET__COuxZg0b__"